import { type KeyboardEvent, useRef } from "react";

/** Returns a ref for the Save button and a textarea keydown handler that focuses it on Cmd/Ctrl+Enter. */
export function useSaveButtonShortcut() {
  const saveButtonRef = useRef<HTMLButtonElement>(null);

  /** Focuses the Save button and stops propagation on Cmd/Ctrl+Enter. */
  const handleDetailsKeyDown = (event: KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key !== "Enter" || (!event.metaKey && !event.ctrlKey)) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    saveButtonRef.current?.focus();
  };

  return { handleDetailsKeyDown, saveButtonRef };
}
